export default defineNuxtPlugin(({ $pinia }) => {
    $pinia.use(() => {
        return { useRequestEvent: useRequestEvent() };
    });
});
